<template>
  <div class="manual-text">
    <div>
      <h1 class="text-center mt-2 mb-10">SII and SPI Analyses Results</h1>
      <p>
        After the KPIs of the simulated project/scenario have been inserted these are shown in the project show page as
        presented in Figure 13, along with some relevant details of each KPI.
      </p>

      <div class="image-container">
        <img src="@/images/manual/kpi-list.png" alt="list of project kpis">
        <div class="img-caption">Figure 13. KPIs of the simulated scenario presented in the project show page.</div>
      </div>

      <p>
        By clicking the “SII SPI Analysis” button, <b>the tool calculates the scores of each KPI</b> while taking into account
        the weights of all the assigned dimensions and sectors. The users can see a <b>plethora of graphical representations</b>
        examining each aspect of KPIs. The analysis has been divided into <b>several groups</b> as seen in figure 14. When the analysis
        first runs, <b>the groups are all open</b>. But, users are able to open and close them as they please.
      </p>

      <div class="image-container">
        <img src="@/images/manual/groups-of-charts-kpi-analysis.png" alt="spi and sii chart 1">
        <div class="img-caption">Figure 14. (Collapsed) Grouped Graphs. Users can open/close whichever one they like.</div>
      </div>

      <p>
        Users are also able to download the results of each of the analysis' graphs, by clicking the button located to
        the top-right of each chart. When pressed, this button will <b>download the chart</b> as it is with its title
        above it in a <b>PNG image format</b>.
      </p>

      <div class="image-container">
        <img src="@/images/manual/kpi-analysis-graph-4.png" alt="spi and sii chart 1">
        <div class="img-caption">Figure 15. The download button.</div>
      </div>

      <p>
        The score of each dimension and sector for each aggregation level is calculated as a weighted average of the
        individual scores of the KPIs belonging to the specific dimension or sector for each aggregation level using the
        following equation (2):
      </p>

      <div class="equation-container">
        <img src="@/images/manual/equation-2.png" alt="equation for the kpis score"
             style="display: block; margin: auto">
      </div>

      <p>
        where n is the number of KPIs in the specific dimension or sector for the specific aggregation level, wi is the
        weight of the ith KPI in the dimension or sector for the specific aggregation level and xi is the score of the
        ith KPI for the specific aggregation level.
        <br><br>
        Example results for one dimension (energy) and one sector (quality of life and prosperity) with 4 aggregation
        levels (building, PEB, PED and city) are presented in Figure 11 using bar charts. By clicking in the top left
        dropdown list the user can select different dimensions and sectors to show their results. The tick boxes
        “include Final SII scores” and “include Final SPI scores” give the option to the user to show in the same graph
        also the final SII and SPI scores of Figure 13 in thinner bars.
      </p>

      <div class="image-container">
        <img src="@/images/manual/kpi-analysis-graph-pair-3.png" alt="spi and sii chart 2">
        <div class="img-caption">Figure 16. Example bar charts showing the scores of the energy dimension (left) and the
          quality of life and prosperity sector (right) in four aggregation levels.
        </div>
      </div>

      <p>
        In addition, Figure 17 presents the average score of each dimension and each sector for one aggregation level
        using spider charts. The results of the other aggregation levels can be shown using the top left dropdown list.
      </p>

      <div class="image-container">
        <img src="@/images/manual/kpi-analysis-graph-pair-2.png" alt="spi and sii chart 3">
        <div class="img-caption">Figure 17. Example scores in spider charts of the building aggregation level.</div>
      </div>

      <p>
        Finally, the final SII and SPI scores are calculated in each aggregation level as an arithmetic mean of the
        individual scores of the dimensions and sectors, respectively, that exist in the specific level. Example results
        are presented in Figure 13, which shows the final SII and SPI scores in each aggregation level of a demo
        project.
      </p>

      <div class="image-container">
        <img src="@/images/manual/kpi-analysis-graph-pair-1.png" alt="spi and sii chart 4">
        <div class="img-caption">Figure 18. Example final SII and SPI scores in each aggregation level of a demo project presented in bar charts.</div>
      </div>
    </div>
  </div>
</template>

<script setup>

</script>

<style scoped>

</style>
